import * as GUID from './GUID.js'

const _patientVideoId = Symbol();
const _name = Symbol();
const _storageGUID = Symbol();

const coalesce = (...args) => args.find(v => v !== undefined);

export class PatientVideo {
	constructor(patientVideoId, name, storageGUID) {
		this.patientVideoId = patientVideoId;
		this.name = name;
		this.storageGUID = storageGUID;
	}
	get patientVideoId() {
		return this[_patientVideoId];
	}
	set patientVideoId(v) {
		if(!Number.isInteger(v))
			throw new TypeError('patientVideoId must be an integer.');
		this[_patientVideoId] = v;
	}
	get name() {
		return this[_name];
	}
	set name(v) {
		if(typeof v !== 'string')
			throw new TypeError('name must be a string.');
		this[_name] = v;
	}
	get storageGUID() {
		return this[_storageGUID];
	}
	set storageGUID(v) {
		if(!GUID.isGUID(v))
			throw new TypeError('storageGUID must be a UUID formatted string.');
		this[_storageGUID] = v;
	}
	toJSON() {
		return {
			patientVideoId: this.patientVideoId,
			name: this.name,
			storageGUID: this.storageGUID
		};
	}
	static fromObject(obj) {
		if(obj === null || typeof obj !== 'object')
			throw new TypeError('obj must be an object.');
		return new this(
			coalesce(obj.patientVideoId, obj.PatientVideoId, null),
			coalesce(obj.name, obj.Name, null),
			coalesce(obj.storageGUID, obj.StorageGUID, null)
		);
	}
}